import Analysis from "../pages/Analysis";
import AuditLog from "../pages/AuditLog";
import VerifyEmail from "../pages/Auth/verify-email";
import Login from "../pages/Auth/login";
import AcceptInvite from "../pages/Auth/accept-invite";
import RejectInvite from "../pages/Auth/reject-invite";

import StaffAcceptInvite from "../pages/staffInvitations/accept-Invite";
import StaffRejectInvite from "../pages/staffInvitations/reject-invite";
import CompanyBranches from "../pages/CompanyBranches";
import CompanyDetails from "../pages/CompanyDetails";
import Dashboard from "../pages/Dashboard";
import Messages from "../pages/Messages";
import Orders from "../pages/Orders";
import Report from "../pages/Reports";
import Services from "../pages/services";
import User from "../pages/Staff";
import Branch from "../pages/Branch";
import { FLEETRIFYROUTEPATH } from "./routesPath";
import {
  STAFF_MANAGEMENT_PERMISSIONS,
  ORDER_PERMISSIONS,
  RELOCATION_PERMISSIONS,
  DASHBOARD_PERMISSIONS,
  MESSAGE_PERMISSIONS,
  FLEET_MANAGEMENT_PERMISSIONS,
} from "../constants/permissions";
import ForgotPassword from "../pages/Auth/forgot-password";
import OnboardingIndividualKYCForm from "../pages/IndividualOnboarding/OnboardingIndividualKycForm";
import OnboardingCompanyKYCForm from "../pages/CompannyOnboarding/OnboardingCompanyKycForm";
import SignUp from "../pages/Auth/sign-up";
import CreateAccount from "../pages/Auth/create-account";
import PasswordVerification from "../pages/Auth/password-verification";
import HomePage from "../pages/HomePage";
import CompanySetUp from "../pages/CompannyOnboarding/CompanySetUp";
import CompanyProfile from "../pages/CompannyOnboarding/CompanyProfile";
import IndividualProfile from "../pages/IndividualOnboarding/IndividualProfile";
import IndividualSetUp from "../pages/IndividualOnboarding/IndividualSetUp";
import IndividualProfileSetUp from "../pages/IndividualOnboarding/IndividualProfileSetup";
import CompanyProfileSetUp from "../pages/CompannyOnboarding/CompanyProfileSetUp";
import ViewOrder from "../pages/Orders/View";
import PasswordReset from "../pages/Auth/password-reset";
import VideoGuide from "../pages/VideoGuide";
import OrderDetails from "../pages/Orders/Details";
import Wallet from "../pages/Wallet";
import WalletSetup from "../pages/Wallet/WalletSetup";
import Settings from "../pages/Settings";
import ViewService from "../pages/services/View";
import TermsAndConditions from "../pages/Auth/Teams-conditions/terms-and-conditions";
import FleetManagementPage from "../pages/Fleet-management/FleetManagementPage";
import OrderRequests from "../pages/OrderRequests";
import Insights from "../pages/Insights";
import RelocationQuotes from "../pages/Relocation";
import ContactSupport from "../pages/ContactSupport";

export const fleetrify_dashboard_route_group = [
  { path: FLEETRIFYROUTEPATH.DASHBOARD, element: Dashboard, permissions: DASHBOARD_PERMISSIONS },

  { path: FLEETRIFYROUTEPATH.BRANCH, element: Branch },

  { path: FLEETRIFYROUTEPATH.USER, element: User, permissions: STAFF_MANAGEMENT_PERMISSIONS },

  { path: FLEETRIFYROUTEPATH.ANALYSIS, element: Analysis },
  { path: FLEETRIFYROUTEPATH.ORDERS, element: Orders, permissions: ORDER_PERMISSIONS },
  { path: FLEETRIFYROUTEPATH.VIEW_ORDER, element: ViewOrder, permissions: ORDER_PERMISSIONS },
  { path: FLEETRIFYROUTEPATH.ORDER_DETAILS, element: OrderDetails, permissions: ORDER_PERMISSIONS },
  { path: FLEETRIFYROUTEPATH.MESSAGE, element: Messages, permissions: MESSAGE_PERMISSIONS },
  { path: FLEETRIFYROUTEPATH.REPORT, element: Report },
  { path: FLEETRIFYROUTEPATH.SETTINGS, element: Settings },

  { path: FLEETRIFYROUTEPATH.AUDIT_LOG, element: AuditLog },
  { path: FLEETRIFYROUTEPATH.SERVICES, element: Services },
  { path: FLEETRIFYROUTEPATH.VIEW_SERVICE, element: ViewService },
  { path: FLEETRIFYROUTEPATH.COMPANY_DETAILS, element: CompanyDetails },
  { path: FLEETRIFYROUTEPATH.COMPANY_BRANCHES, element: CompanyBranches },
  { path: FLEETRIFYROUTEPATH.FLEET_MANAGEMENT, element: FleetManagementPage, permissions: FLEET_MANAGEMENT_PERMISSIONS },
  { path: FLEETRIFYROUTEPATH.HOMEPAGE, element: HomePage },
  { path: FLEETRIFYROUTEPATH.VIDEO_GUIDE, element: VideoGuide },
  { path: FLEETRIFYROUTEPATH.WALLET, element: Wallet },
  { path: FLEETRIFYROUTEPATH.WALLET_SETUP, element: WalletSetup },
  { path: FLEETRIFYROUTEPATH.ORDER_REQUESTS, element: OrderRequests, permissions: RELOCATION_PERMISSIONS },
  { path: FLEETRIFYROUTEPATH.INSIGHTS, element: Insights },
  { path: FLEETRIFYROUTEPATH.RELOCATION_QUOTES, element: RelocationQuotes },
  { path: FLEETRIFYROUTEPATH.CONTACT_SUPPORT, element: ContactSupport },
];

// AUTH
export const fleetrify_auth_route_group = [
  { path: FLEETRIFYROUTEPATH.LOGIN, element: Login },
  { path: FLEETRIFYROUTEPATH.VERIFY_EMAIL, element: VerifyEmail },
  { path: FLEETRIFYROUTEPATH.FORGOT_PASSWORD, element: ForgotPassword },

  {
    path: FLEETRIFYROUTEPATH.ONBOARDINGINDIVIDUALKYCFORM,
    element: OnboardingIndividualKYCForm,
  },
  { path: FLEETRIFYROUTEPATH.REPORT, element: Report },
  {
    path: FLEETRIFYROUTEPATH.ONBOARDINGCOMPANYKYCFORM,
    element: OnboardingCompanyKYCForm,
  },

  { path: FLEETRIFYROUTEPATH.SIGN_UP, element: SignUp },
  { path: FLEETRIFYROUTEPATH.CREATE_ACCOUNT, element: CreateAccount },
  {
    path: FLEETRIFYROUTEPATH.PASSWORD_VERIFICATION,
    element: PasswordVerification,
  },

  {
    path: FLEETRIFYROUTEPATH.PASSWORD_RESET,
    element: PasswordReset,
  },
  { path: FLEETRIFYROUTEPATH.COMPANYSETUP, element: CompanySetUp },

  { path: FLEETRIFYROUTEPATH.ACCEPT_INVITE, element: AcceptInvite },
  { path: FLEETRIFYROUTEPATH.REJECT_INVITE, element: RejectInvite },

  { path: FLEETRIFYROUTEPATH.STAFF_ACCEPT_INVITE, element: StaffAcceptInvite },
  { path: FLEETRIFYROUTEPATH.STAFF_REJECT_INVITE, element: StaffRejectInvite },

  { path: FLEETRIFYROUTEPATH.COMPANYPROFILE, element: CompanyProfile },
  {
    path: FLEETRIFYROUTEPATH.COMPANYPROFILESETUP,
    element: CompanyProfileSetUp,
  },

  { path: FLEETRIFYROUTEPATH.INDIVIDUALSETUP, element: IndividualSetUp },
  { path: FLEETRIFYROUTEPATH.INDIVIDUALPROFILE, element: IndividualProfile },
  {
    path: FLEETRIFYROUTEPATH.INDIVIDUALPROFILESETUP,
    element: IndividualProfileSetUp,
  },

  { path: FLEETRIFYROUTEPATH.TERMS_AND_CONDITIONS, element: TermsAndConditions },
];
